import { defineStore } from "pinia";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: JSON.parse(localStorage.getItem("user")) || null,
    token: localStorage.getItem("token") || null,
    refreshToken: localStorage.getItem("refreshToken") || null,
  }),
  actions: {
    setUser(userData) {
      this.user = userData;
      localStorage.setItem("user", JSON.stringify(userData));
    },
    setToken(tokenData) {
      this.token = tokenData;
      localStorage.setItem("token", tokenData);
    },
    setRefreshToken(refreshTokenData) {
      this.refreshToken = refreshTokenData;
      localStorage.setItem("refreshToken", refreshTokenData);
    },
    clearAuthData() {
      this.user = null;
      this.token = null;
      this.refreshToken = null;
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
    },
    updateUserEmail(email) {
      this.user.Email = email;
      localStorage.setItem("user", JSON.stringify(this.user));
    },
    updateUserName(name) {
      this.user.FullName = name;
      localStorage.setItem("user", JSON.stringify(this.user));
    },
    updateUserPhone(phone) {
      this.user.PhoneNumber = phone;
      localStorage.setItem("user", JSON.stringify(this.user));
    },
  },
});
